import {
  initialUserSessionState,
  UserSessionState,
} from './user-session.state';
import { createReducer, on } from '@ngrx/store';
import * as UserSessionActions from './user-session.actions';
import { Products, ProductCodes } from '../../models/user-profile.model';

export const userSessionReducer = createReducer(
  initialUserSessionState,
  on(UserSessionActions.login, (state) => ({
    ...state,
    isInitializing: true,
    isLoading: true,
  })),
  on(UserSessionActions.loginError, (state) => ({
    ...state,
    alertMessage: 'login.loginError',
    hasError: true,
    isLoading: false,
  })),
  on(UserSessionActions.logoutSuccess, (state, { isTimedOut }) => ({
    ...initialUserSessionState,
    alertMessage: isTimedOut ? 'login.timeOut' : 'login.logoutSuccess',
    hasError: isTimedOut,
  })),
  on(UserSessionActions.dismissAlert, (state) => deleteAlert({ ...state })),
  on(UserSessionActions.getSessionSuccess, (state, { userData }) => {
    const pairedProducts = userData.pairings
      .filter((pairing) => pairing.code in ProductCodes)
      .map((pairing) => ({ ...Products[pairing.code], ...pairing }))
      .reduce((acc, curr) => ({ ...acc, [curr.code]: curr }), {});

    const unpairedEntries = Object.entries(Products).filter(
      ([key]) => !(key in pairedProducts),
    );

    return deleteAlert({
      ...state,
      displayName: userData.displayName,
      isInitializing: false,
      isLoading: false,
      isLoggedIn: true,
      pairedProducts,
      unpairedProducts: Object.fromEntries(unpairedEntries),
    });
  }),
  on(UserSessionActions.getSessionError, (state) => ({
    ...state,
    isInitializing: false,
    isLoading: false,
  })),
  on(UserSessionActions.createUser, (state) => {
    const newState = { ...state };
    delete newState.createUserErrors;
    return newState;
  }),
  on(UserSessionActions.createUserError, (state, { errors }) => ({
    ...state,
    isInitializing: false,
    isLoading: false,
    createUserErrors: errors,
  })),
  on(UserSessionActions.completePairingSuccess, (state) => ({
    ...state,
    isInitializing: true,
    isLoading: true,
    successMessage: 'pairing.success',
  })),
  on(UserSessionActions.unpairProductSuccess, (state, { productCode }) => {
    const newPaired = { ...state.pairedProducts };
    delete newPaired[productCode];

    return {
      ...state,
      pairedProducts: newPaired,
      unpairedProducts: {
        ...state.unpairedProducts,
        [productCode]: Products[productCode],
      },
    };
  }),
);

function deleteAlert(state: UserSessionState): UserSessionState {
  if (state.alertMessage) {
    delete state.alertMessage;
  }
  if (state.hasError) {
    delete state.hasError;
  }
  return state;
}
